import { render } from "./qrActivation.vue?vue&type=template&id=00f02bb5"
import script from "./qrActivation.vue?vue&type=script&lang=js"
export * from "./qrActivation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Build Apps\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__